var _excluded = ["agent", "breadcrumbs", "listingsPerPageMobile", "listingsPerPageDesktop", "notFoundText", "media", "geocoderEndpoint", "googleMapsParams", "enquiryEndpoint"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import MobileFooterCTA from '@domain-group/fe-co-allhomes-agent-mobile-cta';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import { Layout } from '@domain-group/fe-co-allhomes-design-system';
import { AgentEnquiryForm } from '@domain-group/fe-co-allhomes-enquiry-form';
import StickyFooter from '@domain-group/fe-co-allhomes-sticky-footer';
import AllhomesAgentProfilePage from './allhomes-agent-profile-page';
import AllhomesAgentFooter from './components/agent-footer';
import AllhomesAgentModel from './components/agent-model';
import allhomesAgentProfileWrapper from './wrappers';
import { BrandingHeader } from './components/branding-header';
import * as styles from './allhomes-agent-profile.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentProfile = _ref => {
  var agent = _ref.agent,
    breadcrumbs = _ref.breadcrumbs,
    listingsPerPageMobile = _ref.listingsPerPageMobile,
    listingsPerPageDesktop = _ref.listingsPerPageDesktop,
    notFoundText = _ref.notFoundText,
    media = _ref.media,
    geocoderEndpoint = _ref.geocoderEndpoint,
    googleMapsParams = _ref.googleMapsParams,
    enquiryEndpoint = _ref.enquiryEndpoint,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    emailEnquiryModalOpen = _useState2[0],
    setEmailEnquiryModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAppraisal = _useState4[0],
    setIsAppraisal = _useState4[1];
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  if (!agent) {
    return ___EmotionJSX("div", {
      css: styles.notFound
    }, notFoundText);
  }
  var mobile = media.mobile;
  var listingsPerPage = mobile ? listingsPerPageMobile : listingsPerPageDesktop;
  var isPlatinum = agent.brandingLevel === 'PLATINUM';
  var isGold = isPlatinum || agent.brandingLevel === 'GOLD';
  var openModal = function openModal() {
    var appraisal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setEmailEnquiryModalOpen(true);
    setIsAppraisal(appraisal);
  };
  return ___EmotionJSX("div", {
    css: styles.agentProfile
  }, toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING] && isPlatinum && ___EmotionJSX(BrandingHeader, {
    agency: agent.agency
  }), ___EmotionJSX(Layout.PageContainer, null, ___EmotionJSX(Layout.BodySection, {
    css: styles.body
  }, ___EmotionJSX(AllhomesBreadcrumbs, {
    className: "allhomes-breadcrumbs",
    items: breadcrumbs
  }), ___EmotionJSX(AllhomesAgentProfilePage, _extends({
    details: _objectSpread(_objectSpread({}, agent), {}, {
      reviewProfile: isGold ? agent.reviewProfile : undefined
    }),
    listingsPerPage: listingsPerPage,
    onEmailClick: openModal
  }, otherProps))), ___EmotionJSX(Layout.FullWidth, null, ___EmotionJSX(EventBoundary, {
    name: "footer"
  }, ___EmotionJSX(AllhomesAgentFooter, {
    profile: agent,
    geocoderEndpoint: geocoderEndpoint,
    googleMapsParams: googleMapsParams,
    onEmailClick: openModal
  }))), emailEnquiryModalOpen && ___EmotionJSX(AgentEnquiryForm, {
    endpointUrl: enquiryEndpoint,
    logoUrl: agent.agency.images.profilePhoto,
    formTitle: "Contact ".concat(agent.name),
    clientId: agent.id,
    clientType: "AGENT",
    closeCallback: () => setEmailEnquiryModalOpen(false),
    checkedOptions: isAppraisal ? ['PROPERTY_APPRAISAL'] : []
  }), mobile && ___EmotionJSX(StickyFooter, null, ___EmotionJSX(MobileFooterCTA, {
    phone: agent.phone,
    onEmailClick: openModal
  }))));
};
AllhomesAgentProfile.propTypes = {
  notFoundText: PropTypes.string,
  agent: PropTypes.shape(AllhomesAgentModel).isRequired,
  googleMapsParams: PropTypes.shape({
    key: PropTypes.string.isRequired
  }).isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape(AllhomesBreadcrumbs.propTypes.items)).isRequired,
  listingsPerPageDesktop: PropTypes.number,
  listingsPerPageMobile: PropTypes.number,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  }),
  enquiryEndpoint: PropTypes.string.isRequired,
  geocoderEndpoint: PropTypes.string.isRequired
};
AllhomesAgentProfile.defaultProps = {
  notFoundText: 'Could not find the agency',
  listingsPerPageDesktop: 6,
  listingsPerPageMobile: 2,
  media: {}
};
export default allhomesAgentProfileWrapper(AllhomesAgentProfile);
export { AllhomesAgentProfile as BaseAllhomesAgentProfile };